import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/base/base.service';
import { Constants } from '../../../app.constants';

@Injectable({
    providedIn: 'root'
})
export class DeliveryZonesService extends BaseService {
    
    public getDeliveryZonesOptions() {
        return this.getOptions(`${Constants.contextPath}/delivery-zones`);
      }
}